import React from 'react';
import Collapse from 'antd/lib/collapse';
import 'antd/dist/antd.css';
import SingleDiet from './SingleDiet';
import SaveButton from './SaveButton';

const Panel = Collapse.Panel;

class DietContainer extends React.Component {

	constructor() {
		super();
		this.state = {
			showSaveButton: false,
			activeKey: undefined,
		}
	}

	componentWillReceiveProps(nextProps) {
		const warningsChanged = this.props.warnings !== nextProps.warnings;
		if (warningsChanged) {
			this.setState({
				showSaveButton: true,
			})
		}
	}

	activePanel(key) {
		this.setState({
			activeKey: key,
		});
	}

	closeAll() {
		this.activePanel(undefined)
		this.props.closeDiets();
		this.setState({
			showSaveButton: false,
		})
	}

	render() {
		return (
			<div id="profile" className={'profile custom-collapse ' + this.props.open}>
				<div className="profile-content panel">
					<Collapse accordion className="diet-container" activeKey={this.state.activeKey} onChange={(key) => this.activePanel(key)} >
				    <Panel header="Ich verzichte auf..." key="1" showArrow={false} bordered={false} className="relative">
				    	<SingleDiet
				    		list={['fisch', 'huhn', 'gluten', 'milch', 'rind','schwein', 'fleischAllgemein', 'zucker']} />
				    	<SaveButton
				    		show={this.state.showSaveButton}
				    		close={() => this.closeAll()} />
				    </Panel>
				    <Panel header="Ich vertrage keine..." key="2" showArrow={false} bordered={false} className="relative">
				    	<SingleDiet
				    		list={['laktose', 'nuesse', 'erdnuesse', 'walnuesse','senf', 'soja', 'ei']} />
				    	<SaveButton
				    		show={this.state.showSaveButton}
				    		close={() => this.closeAll()} />
				    </Panel>
					</Collapse>
				</div>
			</div>
		);
	}
}

export default DietContainer;


// WEBPACK FOOTER //
// ./src/diets/DietContainer.js